// import React from 'react';

// const Navbar = () => (
//   <header className="fixed top-0 left-0 w-full z-50 bg-pink-100 p-4 flex justify-between items-center">
//     <div className="text-xl font-bold text-purple-800">Salon Logo</div>
//     <nav className="space-x-4">
//       <a href="#about" className="text-purple-600 hover:underline">Home</a>
//       <a href="#services" className="text-purple-600 hover:underline">Services</a>
//       <a href="#gallery" className="text-purple-600 hover:underline">Gallery</a>
//       <a href="#contact" className="text-purple-600 hover:underline">Contact</a>
//     </nav>
//   </header>
// );

// export default Navbar;
import React from 'react';

const Navbar = () => (
  <header 
    // Increased height (h-20), fixed position, professional shadow, bg-white/95 for subtle transparency
    className="fixed top-0 left-0 w-full z-50 bg-pink-100 backdrop-blur-sm shadow-lg h-20"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex justify-between items-center">
        
        {/* Logo/Brand Name: Bolder, bigger, brand color */}
        <div className="text-3xl font-extrabold text-purple-800 tracking-widest italic">
            Looks Trend'z
        </div>
        {/* <div className="text-4xl font-serif text-purple-800 tracking-widest italic">
  Looks Trend'z
</div> */}

        
        {/* Navigation Links: Improved spacing and hover effects */}
        <nav className="space-x-8 hidden md:flex">
          <a 
            href="#about" 
            // Brand colors, strong hover effect with transition
            className="text-purple-600 font-semibold text-lg hover:text-pink-800 transition duration-300 relative group"
          >
            Home
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-pink-600 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
          </a>
          <a 
            href="#services" 
            className="text-purple-600 font-semibold text-lg hover:text-pink-800 transition duration-300 relative group"
          >
            Services
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-pink-600 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
          </a>
          <a 
            href="#courses" 
            className="text-purple-600 font-semibold text-lg hover:text-pink-800 transition duration-300 relative group"
          >
            Courses
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-pink-600 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
          </a>
          <a 
            href="#contact" 
            className="text-purple-600 font-semibold text-lg hover:text-pink-800 transition duration-300 relative group"
          >
            Contact
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-pink-600 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></span>
          </a>
        </nav>
        
        {/* Placeholder for a Mobile Menu Button (Hamburger) */}
        <button className="md:hidden text-purple-800 text-2xl" aria-label="Open menu">
            {/* You would use an icon like FaBars here */}
            ☰
        </button>
        
    </div>
  </header>
);

export default Navbar;